import { ComponentPropsWithRef } from 'react';

export enum ButtonVariants {
  Primary,
  Secondary,
  Text,
}

export interface ButtonProps extends ComponentPropsWithRef<'button'> {
  variant?: ButtonVariants;
  label?: string;
  isLoading?: boolean;
  loadingLabel?: string;
  /** When true (default), button becomes disabled during loading. When false, only aria-disabled is applied */
  disableOnLoading?: boolean;
}
